module.exports = __webpack_public_path__ + "img/bsc.a2dcd586.gif";